"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _grayPercentage = require("gray-percentage");

var _grayPercentage2 = _interopRequireDefault(_grayPercentage);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var theme = {
  title: "Wordpress Theme 2012",
  baseFontSize: "14px",
  baseLineHeight: 1.714,
  scaleRatio: 8 / 5,
  googleFonts: [{
    name: "Open Sans",
    styles: ["400", "400i", "700"]
  }],
  headerFontFamily: ["Open Sans", "sans-serif"],
  bodyFontFamily: ["Open Sans", "sans-serif"],
  bodyColor: "hsla(0,0%,0%,0.73)",
  headerWeight: "700",
  bodyWeight: 400,
  boldWeight: 700,
  overrideStyles: function overrideStyles(_ref, options) {
    var adjustFontSizeTo = _ref.adjustFontSizeTo,
        scale = _ref.scale,
        rhythm = _ref.rhythm;
    return {
      blockquote: {
        fontStyle: "italic",
        paddingLeft: rhythm(1),
        paddingRight: rhythm(1),
        paddingTop: rhythm(1),
        paddingBottom: rhythm(1)
      },
      dl: {
        marginLeft: rhythm(1),
        marginRight: rhythm(1)
      },
      "ol,ul": {
        marginLeft: 0
      },
      ol: {
        listStyle: "decimal outside"
      },
      ul: {
        listStyle: "disc outside"
      },
      li: {
        marginLeft: rhythm(1.5)
      },
      table: _extends({}, scale(-1 / 5), {
        color: (0, _grayPercentage2.default)(46)
      }),
      th: {
        fontWeight: options.boldWeight,
        textTransform: "uppercase",
        color: (0, _grayPercentage2.default)(39)
      },
      a: {
        color: "#21759b"
      },
      "a:hover": {
        color: "#0f3647"
      },
      "a:visited": {
        color: "#9f9f9f"
      }
    };
  }
};
exports.default = theme;